var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.5 233.1",
    style: {
      enableBackground: "new 0 0 156.5 233.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#092833;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_207_",
    className: "st0",
    d: "M78.2,233.1c-2.3-3-4.6-6-6.8-9c-15.8-21.1-29.6-43.4-42.2-66.5c-7.9-14.6-14.8-29.6-21.4-44.8 C5,106.2,2.5,99.5,1.3,92.5c-1.2-7-1.6-14.1-1-21.2c0.8-9.1,3.2-17.8,7-26.1c3.1-6.9,7.3-13.1,12.3-18.8 c7.3-8.2,15.9-14.6,25.9-19.3C52.1,4,59.1,2,66.4,0.9c7.4-1.1,14.7-1.2,22.1-0.2c13.2,1.7,25.2,6.5,35.9,14.4 c7.7,5.6,14.1,12.4,19.4,20.4c4.2,6.4,7.2,13.2,9.5,20.4c1.5,4.8,2.3,9.8,2.8,14.8c0.7,7.1,0.3,14.1-0.8,21.1 c-1.2,7-3.6,13.5-6.3,20c-5.8,13.8-12.2,27.3-19.1,40.6c-6.9,13.4-14.6,26.4-22.6,39.2c-8.9,14-18.4,27.5-28.4,40.7 C78.7,232.6,78.5,232.8,78.2,233.1z M78.2,201c0.4-0.5,0.6-0.8,0.8-1.1c5.5-8.5,11.3-16.9,16.6-25.5c13.1-21.4,24.7-43.6,34.5-66.7 c2.9-6.8,5.9-13.5,6.8-21c0.9-6.8,0.9-13.6-0.6-20.4c-1.7-7.9-4.7-15.3-9.4-22c-3.5-5-7.7-9.4-12.6-13.1 c-9.3-7.1-19.8-11.1-31.4-12.1c-6.8-0.6-13.6,0.1-20.2,1.9c-12.8,3.5-23.4,10.7-31.5,21.2c-4.1,5.3-7.3,11.2-9.3,17.6 c-1.7,5.5-2.8,11-2.9,16.8c-0.1,6.2,0.4,12.4,2.5,18.3c2.4,6.7,5.1,13.3,8,19.7c10.3,22.8,21.9,45,35.4,66.1 C69.2,187.5,73.6,194.2,78.2,201z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_203_",
    className: "st0",
    d: "M104.2,79.1c-0.4,14.6-12.6,25.5-26.6,25.1C63,103.8,51.7,91.8,52.2,77.1 C52.8,63,64.9,51.5,79.4,52.2C93.7,52.9,104.8,65.1,104.2,79.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/PIN.aaefa08df2be2becbfedd16ad889df56.svg";
export { ForwardRef as ReactComponent };